// extracted by mini-css-extract-plugin
export var orderDetails = "_s9-2";
export var orderImage = "_s9-1";
export var orderMeta = "_s9-3";
export var orderSummary = "_s9-0";
export var rightArrow = "_s9-4";